/** Where a saved-quote link opens: the quote's own flow, with the link's
 * query and hash carried over. */
export function legacyQuotePath(
  quoteId: string | undefined,
  search: string,
  hash: string,
): string {
  return `/quotes/${encodeURIComponent(quoteId ?? "")}${search}${hash}`;
}
